export default __webpack_public_path__ + "static/media/mana-logo.56831a92.png";